import React from 'react';
import { cn } from '../lib/utils';

const Progress = React.forwardRef(({ className, value, label, labelClassName, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("relative w-full overflow-hidden rounded-full bg-gray-200", className)}
    {...props}
  >
    <div
      className="h-full w-full flex-1 bg-purple-600 transition-all"
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
    {label ? (
      <div style={{ fontSize: '10px' }} className={cn("absolute inset-0 flex items-center justify-center text-[10px] sm:text-xs font-medium text-white", labelClassName)}>
        {label}
      </div>
    ) : null}
  </div>
));
Progress.displayName = "Progress";

export { Progress }; 